import React from 'react';
import {
  Typography, Table, Popover,
} from 'antd';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faInfoCircle, faCheckCircle, faTimesCircle, faDownload, faExclamation,
} from '@fortawesome/free-solid-svg-icons';

import styles from './LogDetail.module.less';
import useLogDetails from './useLogDetails';

const { Title, Paragraph } = Typography;

function LogDetail(props) {

  const { t } = useTranslation();
  const {
    date, device, resetStatus, systemStatus, bits,
  } = props;

  const {
    columns,
    dataSource,
    columnsDataInfo,
    valueType,
  } = useLogDetails({ bits });

  const AuxModal = () => (
    <>
      <Table
        className={styles.table}
        columns={columnsDataInfo}
        dataSource={valueType}
        style={{
          width: 600,
        }}
        pagination={{ pageSize: 7 }}
        rowKey={(record) => `${record.name}_${record.value}_${record.typeId}`}
      />
    </>
  );

  return (
    <div className={styles.wrapper}>
      <Title level={3}>
        <span>{t('views.log_view.date')}</span>
        {dayjs(date).format('YYYY, MMMM DD hh:mm:ss a')}
      </Title>

      <Title level={4}>
        <span>{t('views.log_view.level')}</span>
        {device}
      </Title>

      <Paragraph>
        <span>Status: </span>
        {resetStatus}
      </Paragraph>

      <Paragraph>
        <span>Code Status: </span>
        {systemStatus}
      </Paragraph>
      <div className={styles.moreInfoContainer}>
        <Popover content={AuxModal} placement="leftTop">
          <FontAwesomeIcon className={styles.iconInfo} icon={faInfoCircle} />
        </Popover>
      </div>

      <Table
        scroll={{ y: '40vh' }}
        className={styles.table}
        columns={columns}
        dataSource={dataSource}
        rowKey={(record) => `${record.category}_${record.bit}`}
      />
      <div>

        <p>
          <b>
            <FontAwesomeIcon className={styles.faINFO} icon={faExclamation} />
          </b>
          {' '}
          {t('views.log_view.iconInfo')}
        </p>
        <p>
          <b>
            <FontAwesomeIcon className={styles.faOK} icon={faCheckCircle} />
          </b>
          {' '}
          {t('views.log_view.iconOk')}
        </p>
        <p>
          <b>
            <FontAwesomeIcon className={styles.faERROR} icon={faTimesCircle} />
          </b>
          {' '}
          {t('views.log_view.iconError')}
        </p>
        <p>
          <b>
            <FontAwesomeIcon className={styles.faWARNING} icon={faDownload} />
          </b>
          {' '}
          {t('views.log_view.iconDownload')}
        </p>
      </div>

    </div>
  );

}

LogDetail.propTypes = {
  // eslint-disable-next-line react/require-default-props
  date: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  device: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  resetStatus: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  systemStatus: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  bits: PropTypes.array,
};

export default LogDetail;
